module.exports = __webpack_public_path__ + "static/media/gts05.37d1cbf3.png";